import { ErrorPage } from "@/shared/components";

export function NotFound() {
  return <ErrorPage title="#404:" subtitle="Can't find the page" />;
}
